import script from "./DatabaseToolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatabaseToolbar.vue?vue&type=script&setup=true&lang=ts"

import "./DatabaseToolbar.vue?vue&type=style&index=0&id=a73ef248&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a73ef248"]])

export default __exports__